<template>

    <ui-form-item v-bind="$componentProps('ui-form-item')" v-slot="{ errors }">

        <ui-date-input v-bind="inputBinds" v-model="innerValue" :error="errors" @navigate="$emit('navigate', $event)" />

    </ui-form-item>

</template>

<script lang="ts">

import { Component, Model, Prop, Vue } from 'vue-facing-decorator';
import { omit } from 'lodash';

import type { ComponentProps } from '@wittignl/js-core';
import { componentPropsMixin, createComponentMixin } from '@wittignl/js-core';

import type { FormItemProps } from './FormItem.vue';
import FormItem, { formItemCompMixin } from './FormItem.vue';

import type { DateInputProps } from '../control/DateInput.vue';
import DateInput, { dateInputCompMixin } from '../control/DateInput.vue';

@Component({
    name: 'ui-form-date-input',
    components: {
        'ui-form-item': FormItem,
        'ui-date-input': DateInput
    },
    mixins: [componentPropsMixin, formItemCompMixin, dateInputCompMixin],
    emits: ['update:modelValue', 'navigate']
})
export default class FormDateInput extends Vue {

    @Prop({ type: String })
    name: string;

    @Model({ type: [String, Array] })
    innerValue: string | string[];

    get inputBinds() {

        return {
            name: this.name,
            ...this.$componentProps('ui-date-input', ['modelValue', 'error']),
            ...omit(this.$attrs, ['class', 'style', 'modelValue', 'onUpdate:modelValue', 'onNavigate'])
        };
    }
}

export type FormDateInputComp = InstanceType<typeof FormDateInput>
export type FormDateInputProps = ComponentProps<FormDateInputComp> & FormItemProps & DateInputProps
export const formDateInputCompMixin = createComponentMixin(FormDateInput, formItemCompMixin, dateInputCompMixin)

</script>